export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./transactions.vue?vue&type=template&id=6b217676&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/player/transactions.vue?vue&type=template&id=6b217676&scoped=true
// module id = C/LC
// module chunks = 0